import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseService, ApiResult } from './base.service';
import { Observable } from 'rxjs';

import { Estancia } from '../models/estancia';
import { EstanciaList } from '../models/estancia-list';

@Injectable({
  providedIn: 'root',
})
export class EstanciasService {

  constructor(protected http: HttpClient, @Inject('BASE_URL') protected baseUrl: string) {

  }

  newEstancia(idTasacion: number, version: number): Observable<Estancia> {
    const url = `${this.baseUrl}api/VisitaEstancias/newEstancia/${idTasacion}/${version}`;
    return this.http.post<Estancia>(url, null);
  }

  getData(idTasacion: number, version: number, pageIndex: number, pageSize: number, sortColumn: string,
    sortOrder: string, filterColumn: string, filterQuery: string): Observable<ApiResult<Estancia>> {

    const url = `${this.baseUrl}api/VisitaEstancias`;

    let params = new HttpParams()
      .set('idTasacion', idTasacion.toString())
      .set('version', version.toString())
      .set('pageIndex', pageIndex.toString())
      .set('pageSize', pageSize.toString())
      .set('sortColumn', sortColumn)
      .set('sortOrder', sortOrder);

    if (filterQuery) {
      params = params
        .set('filterColumn', filterColumn)
        .set('filterQuery', filterQuery);
    }

    return this.http.get<ApiResult<Estancia>>(url, { params });
  }

  get(idTasacion: number, version: number, idEstancia: number): Observable<Estancia> {
    const url = `${this.baseUrl}api/VisitaEstancias/${idTasacion}/${version}/${idEstancia}`;
    console.log(url);
    return this.http.get<Estancia>(url);
  }

  put(item): Observable<Estancia> {
    const url = `${this.baseUrl}api/VisitaEstancias/${item.idTasacion}/${item.idVisitaVersion}/${item.idEstancia}`;
    return this.http.put<Estancia>(url, item);
  }

  post(item): Observable<Estancia> {
    const url = `${this.baseUrl}api/VisitaEstancias/${item.idTasacion}/${item.idVisitaVersion}/${item.idEstancia}`;
    return this.http.post<Estancia>(url, item);
  }

  getTipoEstancia(): Observable<Map<string, string>> {
    const url = `${this.baseUrl}api/VisitaEstancias/getTipoEstancia`;
    console.log(url);
    return this.http.get<any>(url);
  }

  delete(item): Observable<String>{
    const url = `${this.baseUrl}api/VisitaEstancias/RemoveEstancia/${item.idTasacion}/${item.idVisitaVersion}/${item.idEstancia}`;
    console.log("DELETE: "+url);
    return this.http.get<any>(url);
  }
}
